module.exports = __webpack_public_path__ + "ec7acc6e0fc3b2a115592f868ab6e177.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/floor_items/electric-guitar.png
// module id = 3206
// module chunks = 0